<template>
    <div :style="bgStyle">
        <div class="header" :class="containerType">
            <div :class="containerType == 'container-fluid' ? 'container' : null">
                <h1 class="header__title" :style="{ color: styles.title.color }">{{translation.title}}</h1>
                <h2
                    class="header__description"
                    :style="{ color: styles.description.color }"
                >{{translation.description}}</h2>
                <hr :style="{border: `1.5px solid ${color.primary}`}" />
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import image from "../../mixins/image";

export default {
    name: "WidgetTitle",
    mixins: [image],
    props: {
        styles: {
            type: Object,
            required: true
        },
        translation: {
            type: Object,
            required: true
        },
        upload: {
            type: Object | null,
            required: true
        }
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        containerType() {
            if (this.styles.container) {
                return "container";
            } else {
                return "container-fluid";
            }
        },
        bgStyle() {
            if (this.styles.body.type === 1) {
                return {
                    backgroundColor: this.styles.body.background_color
                };
            } else {
                return {
                    backgroundImage: `url(${this.image(this.upload)})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundAttachment: this.styles.body.fixed
                        ? "fixed"
                        : null
                };
            }
        }
    }
};
</script>

<style lang="scss" scoped>
hr {
    margin: 15px 0;
    width: 30%;
    border: 4px solid #000;
}

.header {
    padding: 4rem 2rem 2rem 2rem;
    &__title {
        font-size: 2rem;
        margin: 0;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.4);
    }

    &__description {
        font-size: 1rem;
        margin: 0;
    }
}
</style>
